export default "__VITE_ASSET__1D5lV0ma__"